<template>
  <v-container id="clientes" tag="section">
    <base-v-component heading="Productos internos" />
    <base-material-card color="indigo" icon="mdi-book-multiple" inline class="px-5 py-3">
      <v-toolbar flat color="white">
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="listadoProductos"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Productos internos</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="700px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">{{formTitle}}</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field v-model="editedItem.id" disabled label="Id"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field v-model="editedItem.nombre" label="Nombre"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="editedItem.nombreAlternativo"
                          label="Nombre Alternativo"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-select
                          v-model="editedItem.categoria"
                          item-value="id"
                          item-text="nombre"
                          :items="categoriasSelect"
                          label="Categoria"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          type="number"
                          step="0.01"
                          v-model.number="editedItem.precio"
                          label="Precio"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-select
                          v-model="editedItem.impuesto"
                          :items="impuestosSelect"
                          label="Impuesto"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                  <v-btn color="blue darken-1" text @click="save" :loading="loadingSave">Guardar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.acciones="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="blue"
                min-width="0"
                small
                v-on="on"
                @click="editItem(item)"
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar Producto</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="red"
                min-width="0"
                small
                v-on="on"
                @click="deleteItem(item)"
              >
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Eliminar Producto</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-alert>Sin datos</v-alert>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    loading: false,
    loadingSave: false,
    dialog: false,
    search: "",
    headers: [
      { text: "Nombre", value: "nombre", sortable: false },
      { text: "Categoria", value: "categoriaNombre", sortable: false },
      { text: "Precio", value: "precio", sortable: false },
      { text: "Impuesto", value: "impuestoNombre", sortable: false },
      { text: "Acciones", value: "acciones", sortable: false, align: "right" },
    ],
    editedItem: {
      id: null,
      nombre: "",
      nombreAlternativo: "",
      impuesto: null,
      categoria: null,
      precio: 0,
    },
    defaultItem: {
      id: null,
      nombre: "",
      impuesto: null,
      categoria: null,
      precio: 0,
    },
  }),

  computed: {
    formTitle() {
      return this.editedItem.id === null ? "Nuevo Producto" : "Editar Producto";
    },
    ...mapState({
      categoriasSelect: (state) => state.internos.categorias,
    }),
    ...mapGetters({
      impuestosSelect: "impuestos/getImpuestosSelect",
      listadoProductos: "internos/getProductosListado",
    }),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {},

  methods: {
    reload() {
      const _vue = this;
      this.loading = true;
      this.getProductos().finally(() => {
        _vue.loading = false;
      });
    },
    ...mapActions({
      getProductos: "internos/getProductos",
    }),
    editItem(item) {
      console.log(item);
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.dialog = true;
    },

    deleteItem(item) {
      const _vue = this;
      _vue.loading = true;
      this.$confirm(
        "¿Desea eliminar este producto? Esta acción es irreversible?",
        {
          buttonTrueText: "Aceptar",
          buttonFalseText: "No",
          color: "warning",
          icon: "warning",
          width: 350,
        }
      ).then((res) => {
        if (res) {
          return this.$store
            .dispatch("internos/deleteProducto", item)
            .then((r) => {
              _vue.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Producto eliminado",
              });
            })
            .catch((e) => {
              _vue.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Error al eliminar producto interno: " + e,
              });
            })
            .finally(() => {
              _vue.loading = false;
              this.reload();
              this.close();
            });
        }
      });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      }, 300);
    },

    save() {
      const _vue = this;
      _vue.loadingSave = true;
      delete this.editedItem.categoriaNombre;
      delete this.editedItem.impuestoNombre;
      this.$store
        .dispatch("internos/addProducto", this.editedItem)
        .then((r) => {
          _vue.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Producto guardado",
          });
        })
        .catch((e) => {
          _vue.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al añadir producto interno: " + e,
          });
        })
        .finally(() => {
          _vue.loadingSave = false;
          this.reload();
          this.close();
        });
    },
  },
};
</script>

<style>
</style>